import { Component, Input, OnInit } from '@angular/core';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { PageSize } from '../../../core/dto/page.size';
import { ServicesService } from '../../../core/services/services.service';
import { Pagination } from '../../../core/dto/pagination';
import { SETTINGS } from '../../../core/config/common.settings';

@Component({
  selector: 'app-view-services',
  templateUrl: './view-services.component.html',
  styleUrls: ['./view-services.component.scss'],
})
export class ViewServicesComponent implements OnInit {
  @Input() fleetData: any | undefined;

  servicesData: any[] = [];
  isDeleting = false;

  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;

  serviceDoneByFilter: any;
  serviceTypeFilter: any;

  skeletonTableColumns: any[] = [
    'Service No.',
    'Service Done By.',
    'Service Type',
    'Service Date & Time',
    'Current Millage',
    'Next Service On',
    'Actions',
  ];
  loading = false;

  constructor(
    private serviceService: ServicesService,
    private router: Router,
  ) {}

  ngOnInit(): void {}

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedServices();
  }

  getPagedServices(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        fleet: this.fleetData._id,
        serviceType: this.serviceTypeFilter,
        serviceDoneBy: this.serviceDoneByFilter,
      },
    });
    this.serviceService.getPagedServicesData(payload).then((res: any) => {
      this.loading = false;
      this.servicesData = res[0].data;
      this.pageSize.length = res[0].metadata[0]?.total;
    });
  }

  sort(): void {
    this.sortOrder = this.sortOrder === 1 ? -1 : 1;
    this.getPagedServices();
  }

  viewServiceRecords(id: string): void {
    this.router.navigate([
      `/admin/fleets/${this.fleetData?._id}/service/${id}`,
    ]);
  }

  search(): void {
    this.getPagedServices();
  }

  resetSearch(): void {
    this.serviceDoneByFilter = null;
    this.serviceTypeFilter = null;
    this.getPagedServices();
  }

  changeStatus(id: any, status: boolean): void {
    this.serviceService
      .getPagedServicesData({ _id: id, active: !status })
      .then((res: any) => {
        this.getPagedServices();
      });
  }

  hasPermission(perm: string): boolean {
    return _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), perm);
  }

  async softDeleteConfirm(id: any): Promise<void> {
    this.isDeleting = true;
    try {
      await this.serviceService.softDeleteServiceRecord(id);
      this.isDeleting = false;
      this.getPagedServices();
    } catch (e) {
      this.isDeleting = false;
    }
  }

  cancel(): void {}
  labelValOnServiceType(name: string) {
    let value = '-';
    switch (name) {
      case 'SR': {
        value = 'SR';
        break;
      }
      case 'OWNER': {
        value = 'Vehicle Owner';
        break;
      }
      default: {
        break;
      }
    }
    return value;
  }
}
